/**
 * Shared layout constants and state plumbing for the global nav sidebar.
 *
 * The nav sidebar owns its collapsed state, but other shell-level overlays
 * (e.g. the fullscreen people profile sidebar) need to know how much
 * horizontal space the nav occupies so they can stretch up to — but not over —
 * it. These live here so both producer and consumers stay in sync.
 */

export const NAV_SIDEBAR_EXPANDED_WIDTH = 230;
export const NAV_SIDEBAR_COLLAPSED_WIDTH = 80;

export const NAV_COLLAPSED_STORAGE_KEY = 'robin-global-nav-sidebar-collapsed';

/** Fired on `window` whenever the nav collapsed state changes in this tab. */
export const NAV_COLLAPSED_CHANGE_EVENT = 'robin:nav-collapsed-change';

export const readStoredNavCollapsed = (): boolean | null => {
  try {
    const stored = sessionStorage.getItem(NAV_COLLAPSED_STORAGE_KEY);
    if (stored === null) {
      return null;
    }
    return stored === 'true';
  } catch {
    return null;
  }
};

export const writeStoredNavCollapsed = (value: boolean): void => {
  try {
    sessionStorage.setItem(NAV_COLLAPSED_STORAGE_KEY, value ? 'true' : 'false');
  } catch {
    // sessionStorage may be unavailable in private mode
  }
  // Notify same-tab listeners; the native `storage` event only fires cross-tab.
  window.dispatchEvent(new Event(NAV_COLLAPSED_CHANGE_EVENT));
};
